import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { Instagram } from "lucide-react";
import { resolveImageUrl } from "./ImagePicker";

export default function InstagramGallery() {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/instagram/posts").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 border-t border-border/60" data-testid="instagram-section">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <div>
          <div className="label-caps text-muted-foreground mb-3 flex items-center gap-2">
            <Instagram strokeWidth={2} className="w-4 h-4" />
            03 — {t("instagram.eyebrow")}
          </div>
          <h2 className="font-hand text-5xl md:text-6xl leading-tight">
            {t("instagram.title")}
          </h2>
        </div>
        <a
          href="https://instagram.com/pikkurumiluksia"
          target="_blank"
          rel="noreferrer"
          className="btn-outline"
          data-testid="ig-follow-btn"
        >
          <Instagram strokeWidth={2} className="w-4 h-4" />
          {t("instagram.follow")}
        </a>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {posts.slice(0, 6).map((p) => (
          <a
            key={p.id}
            href={p.post_url}
            target="_blank"
            rel="noreferrer"
            className="group product-image-wrap aspect-square relative"
            data-testid={`ig-post-${p.id}`}
          >
            <img
              src={resolveImageUrl(p.image_url)}
              alt={p.caption || "Instagram post"}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
              <div className="text-white text-xs leading-snug line-clamp-3">
                {p.caption}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
